module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-close-up@2x.png?0.0.53";